<template>
<div>
  <div class="form-group">
    <label for="address-1">Street Address</label>
    <span class="pull-right">(Line 1)</span>
    <p :class="{ 'control': true }">
      <google-autocomplete  v-validate:streetComputed="'required'" :class="{'input form-control': true, 'is-invalid form-control': errors.has('streetAddress') }"
      :has-errors="errors.has('streetAddress')" data-vv-value-path="autocompleteText" name="streetAddress"
      data-vv-name="streetAddress" :country="['us']" v-bind:value="streetComputed" id="address_lookup"
      @input="streetUpdated($event)"
      classname="form-control" placeholder="Enter Street Address" v-on:placechanged="getAddressData"></google-autocomplete>
      <span v-show="errors.has('streetAddress')" class="help is-invalid">{{ errors.first('streetAddress') }}</span>
    </p>
  </div>
  <div class="form-group">
    <label for="address-2">&nbsp;</label>
    <span class="pull-right">(Line 2)</span>
    <street2 v-model="street2Computed" @:input="$emit('update:street2')"></street2>
  </div>
  <div class="row">
    <div class="col-md-6">
      <div class="city">
        <div class="form-group">
          <label for="city">City (Locality)</label>
          <p :class="{ 'control': true }">
          <input v-validate="'required'"  :class="{'input form-control': true, 'is-invalid form-control': errors.has('city') }" name="city" id="city" :value="addressLocality" @input="$emit('update:addressLocality', $event.target.value)">
          <span v-show="errors.has('city')" class="help is-invalid">{{ errors.first('city') }}</span>
          </p>
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="state">
        <div class="form-group">
          <label for="state">State (Administrative Area)</label>
          <p :class="{ 'control': true }">
            <select v-validate="'required'"  :class="{'input form-control': true, 'is-invalid form-control': errors.has('state') }" name="state"  id="state" class="form-control" :value="addressRegion" @input="$emit('update:addressRegion', $event.target.value)">
              <option value="AL">Alabama</option>
              <option value="AK">Alaska</option>
              <option value="AZ">Arizona</option>
              <option value="AR">Arkansas</option>
              <option value="CA">California</option>
              <option value="CO">Colorado</option>
              <option value="CT">Connecticut</option>
              <option value="DE">Delaware</option>
              <option value="DC">District Of Columbia</option>
              <option value="FL">Florida</option>
              <option value="GA">Georgia</option>
              <option value="HI">Hawaii</option>
              <option value="ID">Idaho</option>
              <option value="IL">Illinois</option>
              <option value="IN">Indiana</option>
              <option value="IA">Iowa</option>
              <option value="KS">Kansas</option>
              <option value="KY">Kentucky</option>
              <option value="LA">Louisiana</option>
              <option value="ME">Maine</option>
              <option value="MD">Maryland</option>
              <option value="MA">Massachusetts</option>
              <option value="MI">Michigan</option>
              <option value="MN">Minnesota</option>
              <option value="MS">Mississippi</option>
              <option value="MO">Missouri</option>
              <option value="MT">Montana</option>
              <option value="NE">Nebraska</option>
              <option value="NV">Nevada</option>
              <option value="NH">New Hampshire</option>
              <option value="NJ">New Jersey</option>
              <option value="NM">New Mexico</option>
              <option value="NY">New York</option>
              <option value="NC">North Carolina</option>
              <option value="ND">North Dakota</option>
              <option value="OH">Ohio</option>
              <option value="OK">Oklahoma</option>
              <option value="OR">Oregon</option>
              <option value="PA">Pennsylvania</option>
              <option value="RI">Rhode Island</option>
              <option value="SC">South Carolina</option>
              <option value="SD">South Dakota</option>
              <option value="TN">Tennessee</option>
              <option value="TX">Texas</option>
              <option value="UT">Utah</option>
              <option value="VT">Vermont</option>
              <option value="VA">Virginia</option>
              <option value="WA">Washington</option>
              <option value="WV">West Virginia</option>
              <option value="WI">Wisconsin</option>
              <option value="WY">Wyoming</option>
            </select>
            <span v-show="errors.has('state')" class="help is-invalid">{{ errors.first('state') }}</span>
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-6">
      <div class="form-group">
        <label for="postal">ZIP code (Postal Code)</label>
        <p :class="{ 'control': true }">
          <input v-validate="'required'"  :class="{'input form-control': true, 'is-invalid form-control': errors.has('postalCode') }" name="postalCode"  class="form-control" id="postalCode" :value="postalCode" @input="$emit('update:postalCode', $event.target.value)">
          <span v-show="errors.has('postalCode')" class="help is-invalid">{{ errors.first('postalCode') }}</span>
        </p>
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-group">
        <label for="country">Country / Region</label>
        <p :class="{ 'control': true }">
        <select v-validate="'required'"  :class="{'input form-control': true, 'is-invalid form-control': errors.has('country') }" name="country"  id="country" class="form-control" :value="addressCountry" @input="$emit('update:addressCountry', $event.target.value)">
          <option value="US">United States</option>
          <option value="MX">Mexico</option>
        </select>
        <!-- <input v-validate="'required'"  :class="{'input form-control': true, 'is-invalid form-control': errors.has('country') }" name="country"  class="form-control" id="country" :value="addressCountry" @input="$emit('update:addressCountry', $event.target.value)"> -->
        <span v-show="errors.has('country')" class="help is-invalid">{{ errors.first('country') }}</span>
        </p>

      </div>
    </div>
  </div>

  <mapbox-latlong-2 v-if="showLatLong" v-validate="'longrule|latrule'" :has-errors="errors.has('latlong')" :has-lat-error="errors.has('latlong:latrule')" :has-long-error="errors.has('latlong:longrule')"  data-vv-value-path="latLongVal" data-vv-name="latlong"  name="latlong" ref="mapboxLatLong" v-bind:latitude="latitude" v-bind:longitude="longitude" v-on:update:latitude="$emit('update:latitude', $event)" v-on:update:longitude="$emit('update:longitude', $event)"></mapbox-latlong-2>
  </div>
</div>
</template>

<script>
import Vue from 'vue'
import MaskedInput from 'vue-masked-input'
import MapBoxLatLong2 from './mapbox-latlong-2.vue'
// import RemoteImage from './widgets/remote-image.vue'
// import StoreHours from './widgets/store-hours.vue'
// import HolidayHours from './widgets/holiday-hours.vue'
// import AdditionalProps from './widgets/additional-props.vue'
import Street2 from './street2.vue'
// import datemixin from 'date-mixin.js'
// import geomixin from 'geo-mixin.js'
import GoogleAutocomplete from './google-autocomplete'
import VeeValidate from 'vee-validate'

Vue.use(VeeValidate, { fastExit: false })

export default {
  name: 'PostAddress',
  inject: ['$validator'],
  props: {
    'streetAddress': String,
    'addressLocality': '',
    'addressRegion': '',
    'postalCode': '',
    'addressCountry': '',
    'longitude': 0.0,
    'latitude': 0.0,
    'editStreetAddress': '',
    'showLatLong': true,
    'street2': Array
  },
  data: function () {
    return {
      storedStreet: this.streetAddress
    }
  },
  components: {
    'masked-input': MaskedInput,
    'google-autocomplete': GoogleAutocomplete,
    'mapbox-latlong-2': MapBoxLatLong2,
    'street2': Street2
  },
  methods: {
    getAddressData: function (addressData, placesResultData) {
      let streetAddress = ''
      if (addressData.street_number) {
        streetAddress = addressData.street_number
      }

      if (addressData.route) {
        streetAddress = streetAddress + ' ' + addressData.route
      }

      if (addressData.postal_code) {
        this.$emit('update:postalCode', addressData.postal_code)
      }
      this.$emit('update:addressLocality', addressData.locality)
      this.$emit('update:addressRegion', addressData.administrative_area_level_1)
      this.$emit('update:addressCountry', 'US')
      this.$emit('update:latitude', addressData.latitude)
      this.$emit('update:longitude', addressData.longitude)
      this.streetComputed = streetAddress
      this.$emit('update:streetAddress', streetAddress)
    },
    updatedLongitude: function (newVal) {
      this.$emit('update:longitude', newVal)
    },
    updatedLatitude: function (newVal) {
      this.$emit('update:latitude', newVal)
    },
    streetUpdated: function (newVal) {
      this.storedStreet = newVal
      this.$emit('update:streetAddress', this.storedStreet)
    }
  },
  computed: {
    // a computed getter
    street2Computed: {
      get: function () {
        return this.street2
      },
      set: function (newValue) {
        this.$emit('update:street2', newValue)
      }
    },
    streetComputed: {
      cache: false,
      get: function () {
        if (this.storedStreet) {
          return this.storedStreet
        } else if (this.streetAddress) {
          this.storedStreet = this.streetAddress
          return this.streetAddress
        } else {
          return ''
        }
      },
      set: function (newValue) {
        this.storedStreet = newValue
        this.$emit('update:streetAddress', newValue)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// postal-address.vue?2b8abc14